import Button from "../components/Button";
import { ContentWork } from "../components/ContentWork"
import TestImage from "../assets/panel_surya_rent.jpg"
import Video from "../assets/NEX_Present-Draft_02 (Lowres).mp4"
import { Link } from "react-router-dom";


export default function SimulasiPenghematan(params) {
    return (
        <>
            <div className="lg:mx-16 p-2">
                <div className="lg:flex lg:max-w-full mb-5 w-full">
                    <div className="p-6 ml-8 w-full lg:w-1/2">
                        <div>
                            <h2 className="mb-2 text-4xl font-bold text-gray-900">Simulasi Penghematan</h2>
                            <h2 className="mb-2 text-2xl font-normal text-gray-900">Bagaimana Sewa Milik memberikan anda penghematan setiap bulan</h2>
                            <h4 className="mb-12 mt-12 text-sm font-normal text-gray-900">Komponen-komponen penghematan dari perjanjian Sewa Milik</h4>
                        </div>
                        <div className="mb-5">
                            <li>
                                Tidak ada investasi dan pembelian apapun di awal.
                            </li>
                            <li>
                                Biaya Sewa Milik per bulan akan di bawah biaya listrik per bulan Anda.
                            </li>
                            <li>
                                Tidak ada biaya perawatan.
                            </li>
                        </div>
                        <Button
                            type="button"
                            buttonStyle="bg-black w-1/4"
                            onClick={() => console.log("You clicked on the pink circle!")}
                            children="Lihat"
                        />
                    </div>
                    <img src={TestImage} alt=''
                        className="w-1/1 lg:w-1/3 lg:h-100 rounded-md" />
                </div>
            </div>
                <div className="bg-blue-400 h-1/2 w-full mt-20 p-1 lg:p-7">
                    <div className="mx-8 my-20 p-4 lg:flex lg:max-w-full">
                        <div className="text-white text-3xl w-full lg:w-1/2 lg:text-5xl">
                            Simulasi Penghematan
                        </div>
                        <div className="w-full mt-8 lg:w-1/2 lg:mt-0">
                            <video controls src={Video} type="video/mp4" />
                        </div>
                    </div>
                </div>
                <div className="mt-6 mx-16">
                    <p className="mb-6 font-bold text-3xl">Asumsi-asumsi dalam Simulasi</p>
                    <ContentWork
                        title="Tarif Dasar Listrik"
                        subtitle="Asumsi Pertama"
                        description="Tarif dasar listrik yang kita gunakan dalam simulasi ini adalah ... rupiah per watt"
                    />
                    <ContentWork
                        title="Lama Perjanjian Sewa Milik"
                        subtitle="Asumsi Kedua"
                        description="Lama perjanjian Sewa Milik yang kita gunakan dalam simulasi ini adalah ... tahun"
                    />
                    <ContentWork
                        title="Lahan yang tersedia"
                        subtitle="Asumsi Ketiga"
                        description="Lahan yang digunakan untuk pemasangan panel surya dalam simulasi ini adalah ... meter persegi"
                    />
                    <div className="my-28">
                        <Link to="/mulai-simulasi">
                            <Button
                                type="button"
                                buttonStyle="bg-black w-1/2 lg:w-1/5"
                                onClick={() => console.log("You clicked on the pink circle!")}
                                children="Mulai Simulasi"
                            />
                        </Link>
                    </div>
                </div>
        </>
    )
}